import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet'

import { Auth, API } from 'aws-amplify';
import { getClientUser } from '../../graphql/queries'

function WixCallback() {

  const search = useLocation().search;
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loadingVisible, setLoadingVisible] = useState(true);
  const history = useHistory()
  const [ userDetails, setUserDetails ] = useState(null)
  const authCode = new URLSearchParams(search).get('code');
  const instanceId = new URLSearchParams(search).get('instanceId');

  useEffect(() => {
    OnLoad();
  }, []);

  function OnLoad() {
    Auth.currentSession().then(response => {
      var sub = response.idToken.payload.sub
      var authToken = response.idToken.jwtToken
      fetchData(sub, authToken)
    }).catch( (error) => {
      history.push('/signin')
    });
  }

  async function fetchData(sub, authToken) {
    const response = await API.graphql({ query: getClientUser, variables: { id: sub}})
    if(response.data.getClientUser!=null){
      var user = response.data.getClientUser
      var clientId = user.clientId
      syncData(clientId, authToken)
    }
  }

  function syncData(clientId, authToken){
    const apiName = 'IntegrationAPI'; // replace this with your api name.
    const path = '/wix/oauth'; //replace this with the path you have configured on your API
    const myInit = {
      body: {
        authCode: authCode,
        clientId: clientId,
        instanceId: instanceId
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };

    API
      .post(apiName, path, myInit)
      .then(response => {
        history.push('/?status=synced')
      })
      .catch(error => {
        history.push('/?status=oops')
        console.log('Error executing request.')
        console.log(error)
      });
  }

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Page Title */}
      <Helmet>
        <title>EmPushy | Syncing</title>
      </Helmet>

      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">

        <main>
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto text-center">

            {/* Page header */}
            <div className="mb-5">
              {/* Title */}
              <h1 className="text-2xl md:text-3xl text-gray-800 font-bold">Wix Authorisation</h1>
            </div>

            <h3>Syncing Wix data with EmPushy. Please do not close the page until complete...</h3>
            {loadingVisible ? <div className="sm:flex justify-items-center mt-5 w-full">
              <div className="m-auto">
                <svg className="animate-spin h-8 w-8" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="45" stroke="gray" strokeWidth="10" fill="transparent"
                          strokeLinecap="round"
                          strokeDasharray="283" strokeDashoffset="75"/>
                </svg>
              </div>
            </div> :''}


          </div>
        </main>

      </div>
    </div>
  );
}

export default WixCallback;